import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { UiOuterLink } from 'src/components/UI/OuterLink';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { overlaySlice } from 'src/store/overlay/slice';
import { useSidebarContext } from '../../../helpers/context';
import styles from './styles.module.scss';

type Props = {
  title: string;
  url: string;

  selected?: boolean;
  readyAsSPA?: boolean;
  openNewTab?: boolean;
  isCurrentPageSPA?: boolean;
  icon?: FC<CommonIconProps>;
  subItem?: boolean;
  testId?: string;
  disabled?: boolean;
};

export const ItemLink: FC<Props> = ({
  title,
  selected,
  readyAsSPA = true,
  openNewTab,
  isCurrentPageSPA,
  url,
  icon: Icon,
  subItem,
  testId,
  disabled,
}) => {
  const className = classNames(styles.item, {
    [styles.isSelected]: selected,
    [styles.disabled]: disabled,
    [styles.subItem]: subItem,
  });

  const dispatch = useDispatch();

  const { closeMenu } = useSidebarContext();

  const handleClick = useCallback(() => {
    dispatch(overlaySlice.actions.close());
    closeMenu();
  }, [dispatch, closeMenu]);

  const content = (
    <>
      {Icon && <Icon className={styles.icon} />}

      <span>{title}</span>
    </>
  );

  if (disabled) {
    return (
      <span className={className} data-testid={testId}>
        {content}
      </span>
    );
  }

  if (openNewTab) {
    return (
      <UiOuterLink className={className} href={url} dataTestId={testId} title={title}>
        {content}
      </UiOuterLink>
    );
  }

  if (readyAsSPA && isCurrentPageSPA) {
    return (
      <Link to={url} className={className} data-testid={testId} title={title} onClick={handleClick}>
        {content}
      </Link>
    );
  }

  return (
    <UiInnerNotSPALink className={className} href={url} dataTestId={testId} title={title}>
      {content}
    </UiInnerNotSPALink>
  );
};
